// internationalization
import { useTranslation } from 'react-i18next';

// material ui
import { FormControlLabel, Switch } from '@mui/material';

// components
import useSearchParams from '@/hooks/useStableSearchParams';

/**
 * StackedDataToggle
 * - Reusable toggle for switching between aggregated and stacked data views
 * - State is persisted in URL search params
 */
const StackedDataToggle = ({ namespace = 'dashboards-power-basic' }) => {
  const { t } = useTranslation(namespace);
  const [searchParams, setSearchParams] = useSearchParams();

  const isStacked = searchParams.get('stacked') === 'true';

  const handleToggle = (e) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      if (e.target.checked) {
        next.set('stacked', 'true');
      } else {
        next.delete('stacked');
      }
      return next;
    });
  };

  return (
    <FormControlLabel
      control={
        <Switch checked={isStacked} onChange={handleToggle} size="small" />
      }
      label={t('chart.toggleStacked', {
        defaultValue: 'Show by unit',
      })}
    />
  );
};

export default StackedDataToggle;
